import React from "react";
import { connect } from "react-redux";
import { signIn, signInGoogle } from "../../actions/authActions";
import { hideError } from "../../actions/errorActions";

import Avatar from "@mui/material/Avatar";
import Box from '@mui/material/Box';
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Paper from "@mui/material/Paper";
import Typography from '@mui/material/Typography';

import LoginForm from "./LoginForm";
import { GoogleLogo } from "../helpers/Logos";
import LogoName from "../Logo";
import { Image1 } from "../helpers/Images";

class Login extends React.Component {
  onSubmit = (formValues) => {
    this.props.hideError();
    this.props.signIn(formValues);
  }

  render() {
    return (
      <Grid container component="main" sx={{ height: '100vh' }}>
        <Grid
          item
          xs={false}
          sm={4}
          md={4}
          sx={{
            /* top‑left → bottom‑right gradient from primary.dark → primary.main */
            background: theme =>
              `linear-gradient(
                to bottom right,
                ${theme.palette.primary.dark} 0%,
                ${theme.palette.primary.main} 100%
              )`,
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 16,
              left: 16,
              zIndex: 10,
              color: 'white',
            }}
          >
            <LogoName />
          </Box>
          <Box
            sx={{
              ml: 5,
              top: '20%',
              width: '28%',
              position: 'absolute',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
          >
            {Image1()}
            <Typography variant="body2" sx={{ color: 'white', fontStyle: 'italic' }}>
              "Approaching customers without knowing the value you bring to the table is like going out on the golf course blindfolded. It might work, but you’ll need a bit of luck!"
            </Typography>
            {/* <Typography variant="body2" sx={{ color: 'white', fontStyle: 'italic', mt: 2 }}>
              – Valucadi
            </Typography> */}
          </Box>
        </Grid>

        <Grid item xs={12} sm={8} md={8} component={Paper} elevation={6} square>
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <Box sx={{ mt: 1, maxWidth: 400 }}>
              <LoginForm onSubmit={this.onSubmit} />
              <Grid container>
                <Grid item xs>
                  <Link href="/reset-password" variant="body2">
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="/signup" variant="body2">
                    {"Don't have an account? Sign Up"}
                  </Link>
                </Grid>
              </Grid>
              <Divider sx={{ my: 3 }}>or</Divider>
              <Button
                fullWidth
                variant="outlined"
                onClick={this.props.signInGoogle}
                startIcon={GoogleLogo(20, 20)}
              >
                Log in with Google
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    );
  }
}

export default connect(null, { signIn, signInGoogle, hideError })(Login);
